var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 9C6 10.657 7.343 12 9 12C10.657 12 12 10.657 12 9C12 7.343 10.657 6 9 6C7.343 6 6 7.343 6 9ZM9.372 7.6565L10.7155 9H9.5V10.5H8.5V9H7.273L8.6165 7.6565C8.825 7.448 9.1635 7.448 9.372 7.6565ZM1.0005 9C0.6315 8.9995 0.275 9.1355 0.0005 9.3825V1.5C0 0.6715 0.6715 0 1.5 0H2V9H1.0005ZM5.0005 9H3.0005V0H9.0005C9.553 0 10.0005 0.4475 10.0005 1V5.126C9.681 5.0435 9.346 5 9.0005 5C6.7915 5 5.0005 6.791 5.0005 9ZM6.355 12H1C0.4475 12 0 11.5525 0 11C0 10.4475 0.4475 10 1 10H5.126C5.3285 10.7865 5.764 11.479 6.3545 12H6.355Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInWork);
export default __webpack_public_path__ + "static/media/InWork.c2d491cc2809543c5967c32d80170e0d.svg";
export { ForwardRef as ReactComponent };